import { getLocaleFromPath } from '@tuic/i18n';

import { getCurrentPageName } from './page-name';
import { getPagePlatform } from './page-platform';
import { getWindowTrackerState } from './window-tracker-state';

import type { PageViewData } from '../types';

export const generatePageViewData = (): PageViewData => {
  const url = new URL(window.location.href);
  const locale = getLocaleFromPath(url.pathname);
  const { meta } = getWindowTrackerState();

  return {
    page_category: 'content',
    page_name: getCurrentPageName(),
    page_platform: getPagePlatform(),
    page_country: locale,
    page_language: locale,
    page_url_parameter: getUrlParameters(url),
    page_test_variant: 'original',
    page_b2b: false,
    page_login_status: meta.userIsSignedIn ?? false,
    page_login_variant: meta.userIsSignedIn === true ? 'konto' : undefined,
    page_native_app: meta.isWebview ?? false,
  };
};

const getUrlParameters = (url: URL): string | undefined => {
  const parts = [];

  if (url.searchParams.size > 0) {
    parts.push(url.searchParams.toString());
  }

  if (url.hash.length > 0) {
    parts.push(url.hash);
  }

  if (parts.length === 0) {
    return undefined;
  }

  return parts.join('#');
};
